/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { TemplatesQuoteTemplateSubHeader_QuoteTemplateFragmentDoc, TemplatesQuoteTemplateSubHeader_QuoteTemplateItemFragmentDoc } from '../../../features/templates/quote/TemplatesQuoteTemplateSubHeader.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TemplateQuoteVersionRoutesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionNumber: Types.Scalars['Int']['input'];
  applyOverrides: Types.Scalars['Boolean']['input'];
}>;


export type TemplateQuoteVersionRoutesQuery = { quoteTemplateVersion: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateVersionResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string, projectId?: string | null, hasOverridesDefined: boolean, customizable: boolean, has3dRoomSnapshot: boolean, latestPublishedVersionNumber?: number | null, containsUnpublishedChanged: boolean, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, accessType: Types.TemplateAccessType, isBinding: boolean, usedInOtherTemplates: boolean, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null, type: Types.ItemType }, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, templateId: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null, sharedWithOrganisations: Array<{ __typename: 'Company', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }> } | null } | null }, quoteTemplateLatestAvailableVersion: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateLatestAvailableVersionResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null } | null } };


export const TemplateQuoteVersionRoutesDocument = gql`
    query TemplateQuoteVersionRoutes($id: ID!, $versionNumber: Int!, $applyOverrides: Boolean!) {
  quoteTemplateVersion(
    id: $id
    versionNumber: $versionNumber
    applyOverrides: $applyOverrides
  ) {
    ... on QuoteTemplateVersionResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
        title
        projectId
        ...TemplatesQuoteTemplateSubHeader_QuoteTemplate
        rootItem {
          id
          originVersionNumber
          ...TemplatesQuoteTemplateSubHeader_QuoteTemplateItem
        }
        hasOverridesDefined
      }
    }
  }
  quoteTemplateLatestAvailableVersion(id: $id) {
    ... on QuoteTemplateLatestAvailableVersionResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
      }
    }
  }
}
    ${TemplatesQuoteTemplateSubHeader_QuoteTemplateFragmentDoc}
${TemplatesQuoteTemplateSubHeader_QuoteTemplateItemFragmentDoc}`;

/**
 * __useTemplateQuoteVersionRoutesQuery__
 *
 * To run a query within a React component, call `useTemplateQuoteVersionRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuoteVersionRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuoteVersionRoutesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionNumber: // value for 'versionNumber'
 *      applyOverrides: // value for 'applyOverrides'
 *   },
 * });
 */
export function useTemplateQuoteVersionRoutesQuery(baseOptions: Apollo.QueryHookOptions<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables> & ({ variables: TemplateQuoteVersionRoutesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables>(TemplateQuoteVersionRoutesDocument, options);
      }
export function useTemplateQuoteVersionRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables>(TemplateQuoteVersionRoutesDocument, options);
        }
export function useTemplateQuoteVersionRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables>(TemplateQuoteVersionRoutesDocument, options);
        }
export type TemplateQuoteVersionRoutesQueryHookResult = ReturnType<typeof useTemplateQuoteVersionRoutesQuery>;
export type TemplateQuoteVersionRoutesLazyQueryHookResult = ReturnType<typeof useTemplateQuoteVersionRoutesLazyQuery>;
export type TemplateQuoteVersionRoutesSuspenseQueryHookResult = ReturnType<typeof useTemplateQuoteVersionRoutesSuspenseQuery>;
export type TemplateQuoteVersionRoutesQueryResult = Apollo.QueryResult<TemplateQuoteVersionRoutesQuery, TemplateQuoteVersionRoutesQueryVariables>;